import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { ordersClient } from "@core/clients";
import { CreatePaymentPayload, PaymentFormData } from "@core/types";

const useCreatePaymentMutation = (options: UseMutationOptions<PaymentFormData, any, CreatePaymentPayload> = {}) => {
  return useMutation(
    ["payment", "create"],
    async (payload: CreatePaymentPayload) => {
      return ordersClient.createPayment(payload);
    },
    options
  );
};

export default useCreatePaymentMutation;
